// extracted by mini-css-extract-plugin
module.exports = {"actionsWrapper":"DashboardSettingsDropdown_actionsWrapper_1kEBJ"};